export const settings = {
  http: {
    timeoutMs: 8000, // ms
    timeoutS: 8, // seconds
  },
  brand: {
    name: 'Mable',
    folder: 'mable',
    domain: 'mable.com.au',
    facebook: 'https://www.facebook.com/BetterCaringAustralia', // TODO
    twitter: 'https://twitter.com/BetterCaringAU', // TODO
    youtube: 'https://www.youtube.com/channel/UCbUmsMeSE6iodf8TG7xb3wg', // TODO
  },
  datePickerObj: {
    dateFormat: 'DD/MM/YYYY',
  },
  ionicDateTimeFormat: 'YYYY-MM-DDTHH:mm',
};
